/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Backend_Restart_TitleInputs */

const en_mobile_dev_backend_restart_title = /** @type {(inputs: Mobile_Dev_Backend_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restart required`)
};

const es_mobile_dev_backend_restart_title = /** @type {(inputs: Mobile_Dev_Backend_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reinicio necesario`)
};

/**
* | output |
* | --- |
* | "Restart required" |
*
* @param {Mobile_Dev_Backend_Restart_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_backend_restart_title = /** @type {((inputs?: Mobile_Dev_Backend_Restart_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Backend_Restart_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_backend_restart_title(inputs)
	return en_mobile_dev_backend_restart_title(inputs)
});